import { Box, styled } from '@mui/material';

const TEXT_PRIMARY = '#303c42';
const TEXT_SECONDARY = '#5f6161';

export const PolicyContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  backgroundColor: theme.palette.background.default,
  borderRadius: '4px',
}));

export const PolicyIntro = styled(Box)({
  maxWidth: '760px',
  fontSize: '14px',
  lineHeight: '21px',
  color: TEXT_SECONDARY,
});

export const SectionBlock = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  marginTop: '8px',
});

export const SectionTitle = styled(Box)({
  marginBottom: '8px',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 700,
  color: TEXT_PRIMARY,
});

export const PolicySectionBlock = styled(SectionBlock)({
  '& + &': {
    marginTop: '24px',
  },
});

export const PolicySectionTitle = styled(SectionTitle)(({ theme }) => ({
  padding: '16px',
  backgroundColor: theme.palette.common.white,
  borderRadius: '8px',
}));

export const UnitName = styled(Box)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '14px',
  fontWeight: 600,
  color: TEXT_PRIMARY,
});

export const SectionNote = styled(Box)({
  marginTop: '8px',
  paddingLeft: '16px',
});

export const PermissionText = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  whiteSpace: 'nowrap',
  fontSize: '13px',
  fontWeight: 500,
  color: TEXT_SECONDARY,
});

export const OverrulableDot = styled('span')(({ theme }) => ({
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
}));

export const LoadErrorRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '16px',
});

export const PanelExplanation = styled(Box)({
  padding: '12px 14px',
  border: '1px solid #f5f6f6',
  borderRadius: '4px',
  backgroundColor: '#fafafa',
  fontSize: '13px',
  lineHeight: 1.55,
  color: TEXT_SECONDARY,
});

export const FieldsBlock = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
});

export const SwitchRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  padding: '4px 0',
});

export const SwitchLabel = styled('span')({
  flex: 1,
  minWidth: 0,
  fontSize: '14px',
  fontWeight: 600,
  color: TEXT_PRIMARY,
});

export const TwoColumnGrid = styled(Box)({
  display: 'grid',
  alignItems: 'start',
  gridTemplateColumns: '1fr 1fr',
  gap: '16px',
});

export const NarrowField = styled(Box)({
  maxWidth: '250px',
});

export const RoundingSideLabel = styled(Box)({
  marginTop: '4px',
  marginBottom: '6px',
  fontSize: '12px',
  fontWeight: 600,
  color: TEXT_PRIMARY,
});

export const PermissionHelp = styled('span')({
  fontSize: '13px',
  lineHeight: '19px',
  color: TEXT_SECONDARY,
});

export const PanelErrorRow = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
});

export const PanelFields = styled(Box)({
  '& .MuiTextField-root': {
    height: 'auto',
    minHeight: '49px',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
  '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
});
